import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../_App/Redux/hooks";
import {
  annulerOrderApi,
  createRetourEchangeStatus,
  getEtatRetourEchange,
  getOrderByIdApi,
  ListOnlineOrders,
  ListOrders,
  resetRetrievedOrder,
  resetSelectedOrder,
  saveOrderApi,
  selectedOrder,
  selectOrder,
  SmSannulerOrderApi,
  updateOrderApi,
} from "../../../../_App/Redux/Slices/Orders/OrderSlice";
import TicketCommande from "../../../../Components/Caisses/TicketDeCaisse/TicketDeCaissePaid";
import OrderDetailsModal from "../../../../Components/Caisses/Orders/OrderDetailsModal";
import { useTranslation } from "react-i18next";
import { parametrageCaisse } from "../../../../_App/Redux/Slices/AppParametrages/caisseParametrages/caisseParametrageSlice";
import {
  addClient,
  addToPanier,
  addToRefunded,
  ReservationToPanier,
  resetReduction,
  setClientRemise,
  setNetPrice,
  setNetPriceArticle,
  setOperationType,
  setReduction,
  setRefundedOrder,
} from "../../../../_App/Redux/Slices/Caisse/PanierSlice";
import Swal from "sweetalert2";
import { updateArticleStockApi } from "../../../../_App/Redux/Slices/article/articleSlice";
import { DepotDefautOrganisation } from "../../../../_App/Redux/Slices/depot/depotSlice";
import { useNavigate, useParams } from "react-router-dom";
import { ToastWarning } from "../../../../Shared/Toasts/ToastWarning";
import {
  findTicketsByOrderApi,
  initialeListTicket,
  ListOrderTickets,
  ListTickets,
  updateTicketApi,
} from "../../../../_App/Redux/Slices/tickets/TicketSlice";
import { OrderType } from "../../../../_App/Types/Entites/Orders/OrderType";
import {
  SelectedOrganisation,
  SelectedOrganisationId,
  selectUser,
  societe,
  societeId,
} from "../../../../_App/Redux/Slices/Auth/authSlice";
import { Form } from "react-bootstrap";
import { Type } from "react-toastify/dist/utils";
import { AddArticleDefectueuxApi } from "../../../../_App/Redux/Slices/articledefectueux/articledefectueuxSlice";
import Zoom from "react-medium-image-zoom";
import TicketArticle from "../../../../Components/TicketArticle/TicketArticle";
import { ToastSuccess } from "../../../../Shared/Toasts/ToastSuccess";
import { findAdminBySocieteApi } from "../../../../_App/Redux/Slices/users/userSlice";
import {
  formatDateAndTime,
  ImpressionTicket,
  isExpired,
} from "../../../../_App/Helpers/helpers";
import TicketAvance from "../../../../Components/Caisses/TicketDeCaisse/TicketAvance";
import { formatdate } from "../../../../_App/Helpers/helpers";
import { ArticleType } from "../../../../_App/Types/Entites/ArticleType";
import { findReservationByorderId } from "../../../../_App/Redux/Slices/Reservation/ReservationSlice";
import {
  findPaymentsByOrderApi,
  findPaymentsByTicketApi,
} from "../../../../_App/Redux/Slices/payments/PaymentSlice";
import { PrintAction } from "../../../../Shared/Hardware/PrintAction";
import iconv from "iconv-lite"; // npm i iconv-lite
import _ from "lodash";
import { TiroirAction } from "../../../../Shared/Hardware/TiroirAction";

interface PanierItem {
  article: ArticleType;
  quantity: number;
  prix_unitaire: number;
  prix_total: number;
  paid_quantity: number;
  sold_quantity: number;
  remise: any;
  remiseClient: number;
  prixNet: number;
  free: boolean;
  type?: String;
  note?: String;
  remisepropsition?: any;
  defaut_id?: any;
  outOFStock: boolean;
  qtemax?: any;
}

const PaidOrder = ({ retrievedOrder }: any) => {
  const navigate = useNavigate();
  const organisation_id = useAppSelector(SelectedOrganisationId);
  const today = formatdate(new Date());

  const dispatch = useAppDispatch();
  const parametrage = useAppSelector(parametrageCaisse);
  const { OrderId } = useParams<{ OrderId?: string }>();

  const [showModalTicket, setShowModalTicket] = useState(false);
  const [showOrderDetailsModal, setShowOrderDetailsModal] = useState(false);
  const currentDepot = useAppSelector(DepotDefautOrganisation);
  const [typeAction, setTypeAction] = useState("");

  const { t } = useTranslation();
  const btnClass = parametrage && parametrage.barcodeOnly ? " big-btn" : "";
  const boxClass = parametrage && parametrage.barcodeOnly ? " light-box" : "";
  const bgClass =
    parametrage && parametrage.barcodeOnly ? " light-background" : "";
  const [refundedItems, setRefundedItems] = useState<any>([]);
  const [refundMode, setRefundMode] = useState<Boolean>(false);
  const [ticketselected, setticketselected] = useState();
  const ticket = useAppSelector(ListOrderTickets);
  const userconnecte = useAppSelector(selectUser);
  const user = useAppSelector(selectUser);
  const isOnlineSale = user?.role_id?.libelle === "onlineSale";
  const listOrders = useAppSelector(
    isOnlineSale ? ListOnlineOrders : ListOrders,
  );
  const [openedOrder, setopenedOrder] = useState<any>(null);
  const [etatRetour, setEtatRetour] = useState<any | null>(null);
  const [showModelTicketArticle, setshowModelTicketArticle] = useState(false);
  const [showModelAvanceTicketArticle, setshowModelAvanceTicketArticle] =
    useState(false);
  const Organisation = useAppSelector(SelectedOrganisation);
  const Societe = useAppSelector(societe);
  const societe_id = useAppSelector(societeId);
  const [listTicket, setlistTicket] = useState<any[]>([]);
  const [admin, setAdmin] = useState<any | undefined>(undefined);
  const [rand, setRand] = useState(false);
  const [Reservation, setReservation] = useState<any>();

  useEffect(() => {
    const fetch = async () => {
      dispatch(initialeListTicket());

      if (OrderId) {
        const reslt = await dispatch(getOrderByIdApi(OrderId));
        setopenedOrder(reslt.payload);

        const findReservation = await dispatch(
          findReservationByorderId(OrderId),
        );
        setReservation(findReservation.payload);

        if (openedOrder && openedOrder.status === "reservation") {
          const findReservation = await dispatch(
            findReservationByorderId(openedOrder._id),
          );
          setReservation(findReservation.payload);
        }
        const response = await dispatch(getEtatRetourEchange(OrderId));
        if (response.payload.success) setEtatRetour(response.payload.data);

        dispatch(findTicketsByOrderApi(OrderId));
      }

      if (societe_id) {
        const res = await dispatch(findAdminBySocieteApi(societe_id));
        if (res.payload.success) setAdmin(res.payload.data);
      }
    };

    fetch();
  }, [OrderId, rand]);

  const AjoutAvance = async () => {
    if (Reservation && OrderId) {
      const todayDate = new Date();
      const echeanceDate = new Date(Reservation?.date_echeance);

      if (
        (user?.role_id?.libelle !== "admin" && todayDate <= echeanceDate) ||
        user?.role_id?.libelle === "admin"
      ) {
        if (parametrage && parametrage.barcodeOnly) {
          await dispatch(
            ReservationToPanier({
              avance: Reservation?.avance?.reduce(
                (accumulator: any, currentValue: any) =>
                  accumulator + currentValue.total,
                0,
              ),
              order_id: OrderId,
              totalNet: Reservation?.achat_totalNet,
              total: openedOrder?.total,
              items: openedOrder ? openedOrder.items : [],
              client: Reservation?.infoclient.client,
              reservation: Reservation,
            }),
          );
          await dispatch(
            setClientRemise(Reservation?.infoclient.client.remise),
          );
          await dispatch(setNetPriceArticle());
          // window.location.href = "/caisse";
          navigate("/caisse");
        }
      } else {
        Swal.fire({
          icon: "warning",
          title: "Attention",
          text: "l'avance  dépassée la date d'échéance, vous voulez quand même continuer",
          confirmButtonText: "OK",
        }).then(async () => {
          if (parametrage && parametrage.barcodeOnly) {
            await dispatch(
              ReservationToPanier({
                avance: Reservation?.avance?.reduce(
                  (accumulator: any, currentValue: any) =>
                    accumulator + currentValue.total,
                  0,
                ),
                order_id: OrderId,
                totalNet: Reservation?.achat_totalNet,
                total: openedOrder?.total,
                items: openedOrder ? openedOrder.items : [],
                client: Reservation?.infoclient.client,
                reservation: Reservation,
              }),
            );
            await dispatch(
              setClientRemise(Reservation?.infoclient.client.remise),
            );
            await dispatch(setNetPriceArticle());
            // window.location.href = "/caisse";
            navigate("/caisse");
          }
        });
      }
    }
  };
  // Handle adding/removing items to/from the refundedItems array
  const handleItemCheck = (item: any, isChecked: boolean) => {
    if (isChecked) {
      console.log("ticket", ticket);
      const calculQuantiteReste = ticket
        .filter((t) => t.type !== "Avance") // exclude 'Avance' tickets
        .reduce((total, t) => {
          const q = t.ticket_order.items.reduce(
            (acc, e) =>
              e.article._id === item.article._id ? acc + e.quantity : acc,
            0,
          );
          return total + q;
        }, 0);

      setRefundedItems([
        ...refundedItems,
        {
          ...item,
          ...{ Qteretour: calculQuantiteReste },
          ...{ type: "", note: null, image: null },
        },
      ]);
    } else {
      setRefundedItems(
        refundedItems.filter((i: any) => i.article._id !== item.article._id),
      );
    }
  };
  const changeQteEchange = (element: any, Qteretour: number) => {
    const findindex = refundedItems.findIndex(
      (ei: any) => ei?.article?._id === element?.article._id.toString(),
    );
    console.log("refundedItems", refundedItems);
    console.log("element", element);
    console.log("findindex", findindex);

    if (findindex !== -1) {
      const copie = [...refundedItems];
      const calculQuantitereste = ticket
        .filter((t) => t.type !== "Avance")
        .reduce((total, t) => {
          console.log("t", t);
          const q = t.ticket_order.items.reduce(
            (acc, e) =>
              e.article._id.toString() === element.article._id.toString()
                ? acc + e.quantity
                : acc,
            0,
          );
          return total + q;
        }, 0);
      console.log(
        "Qteretour",
        Qteretour,
        "calculQuantitereste",
        calculQuantitereste,
      );
      if (Qteretour <= calculQuantitereste) {
        copie[findindex].Qteretour = Qteretour;
        console.log("copie", copie);
        setRefundedItems(copie);
      } else {
        ToastWarning(
          "La quantité souhaitée à retourner/échanger est supérieure à la quantité achetée restante",
        );
      }
    }
  };
  const changeinfodefaut = (index: number, name: string, value: any) => {
    const element = openedOrder?.items[index];
    const findindex = refundedItems.findIndex(
      (item: any) => item?.article?._id === element?.article._id,
    );

    if (findindex !== -1) {
      const copie = [...refundedItems];

      if (name === "quantite") {
        const calculQuantitereste = ticket
          .map((t) =>
            t.ticket_order.items.reduce(
              (acc, e) =>
                e.article._id === copie[findindex].article._id
                  ? acc + e.quantity
                  : acc,
              0,
            ),
          )
          .reduce((total, quantity) => total + quantity, 0);
        if (parseInt(value) <= calculQuantitereste) {
          copie[findindex][name] = value;
          setRefundedItems(copie);
        } else {
          ToastWarning(
            "La quantité défectueuse est supérieure à la quantité achetée restante",
          );
        }
      } else {
        copie[findindex][name] = value;
        console.log("copie", copie);
      }

      setRefundedItems(copie);
    }
  };

  const headToRetour = async (amount: any, refunded: any) => {
    Swal.fire({
      title: `Voulez vous vraiment ${typeAction} ces articles ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085D6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const findArticleDefaut = refunded
          .filter((item: any) => item.type)
          .map((item: any) => {
            return { ...item, order: openedOrder?._id };
          });
        const resp: any = await dispatch(
          AddArticleDefectueuxApi({
            datalistAricle: findArticleDefaut,
            organisation_id: organisation_id,
            societe_id: societe_id,
            order: OrderId,
          }),
        );
        if (!etatRetour && typeAction === "Retour") {
          const responseSMS = await dispatch(
            createRetourEchangeStatus({
              retourEchangeData: {
                order_id: OrderId,
                confirmed:
                  parametrage && parametrage.sms_confirmation ? false : true,
                itemsToReturn: refunded,
                itemsToExchange: [],
                organisation_id: organisation_id,
                societe_id: societe_id,
                date: new Date(),
                user_id: user?._id,
                cloture: false,
              },
              smsInfo:
                parametrage && parametrage.sms_confirmation
                  ? {
                      mobile: admin.mobile ? admin.mobile : admin[0], // Replace with dynamic mobile number
                      message: `Retour: https://caisse.scaniny.com/confirmation/${societe_id}/${OrderId}`,
                      base64Image: null, // Optional: Add base64 image string if needed
                    }
                  : null,
            }),
          );
          if (parametrage && parametrage.sms_confirmation) {
            if (responseSMS.payload.success) {
              setRand(!rand);
              Swal.fire({
                icon: "success",
                title: "Succès",
                text: "SMS envoyé avec succès!",
                confirmButtonText: "OK",
              }).then((result) => {
                if (result.isConfirmed) {
                  navigate("/caisse");
                }
              });
            }
          } else window.location.reload();
        }

        if (
          (parametrage && parametrage.sms_confirmation) ||
          (typeAction === "Retour" &&
            ((etatRetour && etatRetour.confirmed) ||
              user?.role_id?.libelle === "onlineSale"))
        ) {
          etatRetour.itemsToReturn.forEach(async (item: any) => {
            if (item.type) {
              await dispatch(
                addToPanier({
                  article: item.article,
                  quantity: -item.quantite, // Negative quantity for returns
                  sold_quantity: -item.quantite,
                  prix_unitaire: item.prix_unitaire, // Negative price for returns
                  prix_total: -(item.prix_unitaire * item.Qteretour), // Total price negative
                  paid_quantity: 0,
                  type: "defaut",
                  note: item.note,
                  remise: item.remise || 0,
                  remiseClient: 0,
                  prixNet: -(
                    item.prix_unitaire *
                    item.Qteretour *
                    (item.remise / 100)
                  ), // Negative net price
                }),
              );
            }
            console.log(item.quantity, item.Qteretour);
            const sold = item.quantity - item.Qteretour;
            await dispatch(
              addToPanier({
                article: item.article,
                quantity: -item.Qteretour, // Negative quantity for returns
                sold_quantity: item.quantity - item.Qteretour,
                prix_unitaire: item.prix_unitaire, // Negative price for returns
                prix_total: -(item.prix_unitaire * item.Qteretour), // Total price negative
                paid_quantity: 0,
                type: "",
                remise: item.remise || 0,
                remiseClient: 0,
                prixNet: -(
                  item.prix_unitaire *
                  item.Qteretour *
                  (item.remise / 100)
                ), // Negative net price
              }),
            );
          });
          // Reset refunded items array and refund mode
          setRefundedItems([]);
          setRefundMode(false);
          let data = { ...openedOrder, etatRetour };
          dispatch(setRefundedOrder(data));
          dispatch(resetSelectedOrder());
          dispatch(
            setOperationType({ type: typeAction, refunded: refundedItems }),
          );
          dispatch(addClient(openedOrder?.client_id));
          navigate("/caisse");
        }

        if (typeAction === "Echange") {
          refunded.forEach(async (item: any) => {
            if (item.type) {
              await dispatch(
                addToRefunded({
                  article: item.article,
                  quantity: -item.quantite, // Negative quantity for returns
                  sold_quantity: -item.quantite,
                  prix_unitaire: item.prix_unitaire, // Negative price for returns
                  prix_total: -(item.prix_unitaire * item.Qteretour), // Total price negative
                  paid_quantity: 0,
                  type: "defaut",
                  note: item.note,
                  remise: item.remise || 0,
                  remiseClient: 0,
                  prixNet: -(
                    item.prix_unitaire *
                    item.Qteretour *
                    (item.remise / 100)
                  ), // Negative net price
                }),
              );
              dispatch(setNetPrice());
            }
            const qterestante =
              Number(item.Qteretour) - (Number(item.quantite) || 0);
            console.log("qterestante", qterestante);
            if (qterestante > 0) {
              await dispatch(
                addToRefunded({
                  article: item.article,
                  quantity: -qterestante, // Negative quantity for returns
                  sold_quantity: -qterestante,
                  prix_unitaire: item.prix_unitaire, // Negative price for returns
                  prix_total: -(item.prix_unitaire * qterestante), // Total price negative
                  paid_quantity: 0,
                  type: "",
                  remise: item.remise || 0,
                  remiseClient: 0,
                  prixNet: -(
                    item.prix_unitaire *
                    item.Qteretour *
                    (item.remise / 100)
                  ), // Negative net price
                }),
              );
              dispatch(setNetPrice());
            }
          });
          // Reset refunded items array and refund mode
          setRefundedItems([]);
          setRefundMode(false);
          dispatch(setRefundedOrder(openedOrder));
          dispatch(resetSelectedOrder());
          dispatch(
            setOperationType({ type: typeAction, refunded: refundedItems }),
          );
          dispatch(addClient(openedOrder?.client_id));
          navigate("/caisse");
        }
      }
    });
  };
  const onlineRefund = async () => {
    // ... (Existing Logic for Retour / Avoir) ...
    // [Keeping your existing code for type === 'retour' intact]

    if (openedOrder) {
      try {
        const { value: deliveryFee } = await Swal.fire({
          title:
            "Voulez-vous rembourser les frais de livraison à la société de livraison ?",
          input: "number",
          inputLabel: "frais de livraison",
          inputValue: openedOrder.societe_livraison?.frais_livraison,
          showCancelButton: true,
          confirmButtonText: "Oui",
          cancelButtonText: "Non, passe",
          inputValidator: (value) => {
            const parsedValue = parseFloat(value);
            if (!value || isNaN(parsedValue) || parsedValue <= 0) {
              return "Please enter a valid amount!";
            }
          },
        });

        let parsedDeliveryFee = 0;
        if (deliveryFee !== null) {
          parsedDeliveryFee = parseFloat(deliveryFee);
        }

        openedOrder.items.forEach((value: any) => {
          dispatch(
            updateArticleStockApi({
              id: value.article._id,
              depotId: currentDepot._id,
              soldQuantity: -value.qteretour || -value.quantity,
              type: value?.type,
              defaut_id: value?.defaut_id,
            }),
          );
        });

        let avoir = { ...openedOrder };

        avoir.items = avoir.items.map((item: any) => ({
          ...item,
          quantity: item.quantity * -1,
          prix_total: item.prix_total * -1,
          prixNet: item.prixNet * -1,
        }));

        avoir.total = -avoir.total;
        avoir.totalNet = -avoir.totalNet;
        avoir.status = "Avoir";
        avoir.date = new Date();
        avoir.organisation_id = avoir.organisation_id._id;
        avoir.client_id = avoir.client_id._id;
        avoir.perteRetour = parsedDeliveryFee;

        delete avoir._id;
        delete avoir.typeRemise;
        delete avoir.retour_echanges;
        delete avoir.createdAt;

        const saveResponse = await dispatch(saveOrderApi(avoir));

        if (!saveResponse?.payload?.success) {
          throw new Error("Avoir saving failed");
        }

        const updateResponse = await dispatch(
          updateOrderApi({
            orderId: openedOrder._id,
            status: "Retour",
          }),
        );

        if (!updateResponse?.payload?.success) {
          throw new Error("Order update failed");
        }

        Swal.fire({
          icon: "success",
          title: "Succès",
          text: "Avoir créé et commande mise à jour avec succès !",
          timer: 2000,
          showConfirmButton: false,
        });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Erreur",
        });
      }
      navigate("/commandes");
    }
  };
  const annulerOrder = async (
    openTiroire: any = true,
    etat: any = true,
    demande: any = false,
  ) => {
    let resp;
    const obj = { orderId: OrderId, etat: etat, demande };
    resp = await dispatch(annulerOrderApi(obj));
    if (openTiroire) await TiroirAction();

    if (resp && resp.payload.success) {
      ToastSuccess(resp.payload.message);
      navigate("/commandes");
    }
  };
  const sendSmsDemandeAnnulation = async () => {
    const obj = {
      id: OrderId,
      societeId: societe_id,
      usernom: userconnecte?.nom,
      userprenom: userconnecte?.prenom,
    };
    const resp = await dispatch(SmSannulerOrderApi(obj));
    if (resp && resp.payload.success) {
      ToastSuccess(resp.payload.message);
      navigate("/commandes");
    }
  };
  useEffect(() => {
    if (etatRetour && typeAction === "Retour") {
      headToRetour(0, etatRetour.itemsToReturn);
    }
  }, [typeAction]);
  const handleReturnStock = async (items: PanierItem[], ticket: string) => {
    console.log("items", items);
    Swal.fire({
      title: "Voulez-vous retourner les articles en stock ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then(async (result) => {
      if (result.isConfirmed) {
        items.map((article: any) => {
          if (article.quantity < 0) {
            dispatch(
              updateArticleStockApi({
                id: article.article._id,
                depotId: currentDepot._id,
                soldQuantity: article.quantity,
                type: article?.type,
                organisation: organisation_id,
                defaut_id: article?.defaut_id,
              }),
            );
            dispatch(
              updateTicketApi({
                id: ticket,
                data: {
                  data: {
                    returnedArticlesToStock: true,
                  },
                },
              }),
            );
          }
        });
      }
    });
  };
  const allTickets = openedOrder?.tickets || [];
  const soldProducts: any = {};

  allTickets.forEach((ticket: any) => {
    const sign = ticket.type === "vente" ? 1 : -1;
    if (ticket.type !== "Avance") {
      ticket.ticket_order.items.forEach((item: any) => {
        const product = item.article._id;
        const quantity = item.quantity;

        if (!soldProducts[product]) soldProducts[product] = 0;
        soldProducts[product] += quantity;
      });
    }
  });

  //

  //call impression
  const callImpression = async (item: any, type: any) => {
    console.log("callImpression");
    let dataTicket;
    const payments = await dispatch(findPaymentsByTicketApi(item._id)).unwrap();
    const groupedByPaymentMethod = _.groupBy(payments, "payment_method");
    if (type === "Ticket Paid") {
      dataTicket = {
        ticket: item,
        societe: item?.ticket_order?.societe_id,
        organisation: item?.ticket_order?.organisation_id,
        user: item?.ticket_order?.user_id,
        vendeur: item?.ticket_order?.vendeur,
        paymentList: groupedByPaymentMethod,
        date: new Date(item.createdAt),
      };
    } else if (type === "Avance") {
      dataTicket = {
        ticket: item,
        societe: item?.ticket_order?.societe_id,
        organisation: item?.ticket_order?.organisation_id,
        user: item?.ticket_order?.user_id,
        vendeur: item?.ticket_order?.vendeur,
        date: new Date(item.createdAt),
        paymentList: groupedByPaymentMethod,
        totalavance: Reservation.avance.reduce(
          (accumulator: any, currentValue: any) =>
            accumulator + currentValue.total,
          0,
        ),
        Reservation: Reservation,
      };
    }

    const lines: any = ImpressionTicket(type, dataTicket, parametrage);
    console.log("lines", lines);
    const finalBuffer = (() => {
      const allBytes: number[] = [];
      lines.forEach((line: any) => {
        if (line instanceof Uint8Array) {
          allBytes.push(...line);
        } else {
          const buf = iconv.encode(line + "\n", "ISO-8859-1");
          allBytes.push(...buf);
        }
      });
      return new Uint8Array(allBytes);
    })();
    console.log("sendToPrint", finalBuffer);
    await PrintAction(finalBuffer, parametrage.OpenTiroire);
  };
  return (
    <div>
      <div className="cart-header">
        <div className="widget-message" style={{ padding: "10px" }}>
          <div className="widget-title mb-10">
            <h5 onClick={() => console.log(listOrders)}>
              {t("Commande ") + openedOrder?.order_number}
            </h5>
            <button
              className="delete-button"
              style={{
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
              }}
              onClick={() => {
                dispatch(resetSelectedOrder());
                dispatch(resetRetrievedOrder());
                dispatch(resetReduction());
              }}
            >
              <i className="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>

      {parametrage && openedOrder ? (
        parametrage.barcodeOnly ? (
          <div className=" row widget-content searchable-container list full-width">
            <div className="searchable-items list full-width">
              <div className="items items-header-section row align-items-center full-width paidOrder-row">
                <div className="col-2 text-center">
                  <h4 onClick={() => console.log(refundedItems)}>Article</h4>
                </div>
                <div className="col-2 text-center">
                  <h4>{t("Prix")}</h4>
                </div>
                <div className="col-2 text-center">
                  <h4>{t("Remise")}</h4>
                </div>
                <div className="col-2 text-center">
                  <h4>{t("Quantité")}</h4>
                </div>
                {refundMode && (
                  <div className="col-1 text-center">
                    <h4>{t("Quantité retour/echange")}</h4>
                  </div>
                )}
                <div className="col-2 text-center">
                  <h4>{t("Total")}</h4>
                </div>
              </div>
              {openedOrder &&
                ticket
                  .slice()
                  .reverse()
                  .map((itemT: any, i: number) => (
                    <div
                      key={i}
                      className="timeline-item mb-4 p-3 border-start border-3 border-primary position-relative bg-white shadow-sm rounded"
                    >
                      <div
                        className="timeline-marker position-absolute top-0 start-0 translate-middle bg-primary rounded-circle"
                        style={{ width: "1rem", height: "1rem" }}
                      ></div>

                      <h5 className="mb-1">
                        <strong className="text-primary">
                          {itemT.type === "Avance" ? "Avance" : itemT.process}
                          {itemT.type === "Avance"
                            ? " Montant d'avance : " +
                              itemT.ticket_order.totalNet
                            : null}
                        </strong>{" "}
                        <small className="text-muted ms-2">
                          {formatDateAndTime(itemT.createdAt)}
                        </small>
                      </h5>

                      {/* Conditional Return Stock button */}
                      {itemT.process === "Echange" && isOnlineSale
                        ? !itemT.returnedArticlesToStock && (
                            <button
                              className="btn btn-danger mb-2"
                              onClick={() =>
                                handleReturnStock(
                                  itemT.ticket_order.items,
                                  itemT._id,
                                )
                              }
                              style={{
                                position: "absolute",
                                right: 30,
                                top: 3,
                              }}
                            >
                              Articles pas encore retournés en stock !
                            </button>
                          )
                        : null}

                      {/* Items */}
                      {itemT.ticket_order.items.map(
                        (item: any, index: number) => (
                          <>
                            <div className="items row align-items-center full-width paidOrder-row">
                              {refundMode &&
                              soldProducts &&
                              soldProducts[item.article._id] > 0 &&
                              item.quantity > 0 &&
                              itemT.type !== "Avance" ? (
                                <div className="col-1 text-center">
                                  <input
                                    type="checkbox"
                                    onChange={(e) =>
                                      handleItemCheck(item, e.target.checked)
                                    }
                                  />
                                </div>
                              ) : null}
                              <div className="col-2 text-center">
                                <img
                                  src={
                                    item.article.image[0] ||
                                    "/assets/img/no-image.jpg"
                                  }
                                  width="50"
                                />
                                <p>{item.article.titre.fr}</p>
                              </div>
                              <div className="col-2 text-center">
                                {item.prix_unitaire.toFixed(3)}
                              </div>
                              <div className="col-2 text-center">
                                {item.remise || 0}%
                              </div>
                              <div
                                className="col-2 text-center"
                                onClick={() => console.log(refundedItems)}
                              >
                                {refundMode &&
                                soldProducts[item.article._id] > 0
                                  ? soldProducts[item.article._id]
                                  : item.quantity}
                              </div>
                              {refundMode &&
                                soldProducts &&
                                soldProducts[item.article._id] > 0 &&
                                item.quantity > 0 &&
                                itemT.type !== "Avance" && (
                                  <div className="col-1 text-center">
                                    <input
                                      type="number"
                                      value={
                                        refundedItems.find(
                                          (e: any) =>
                                            e.article._id === item.article._id,
                                        )?.Qteretour || 0
                                      }
                                      onChange={(e) =>
                                        changeQteEchange(
                                          item,
                                          Number(e.target.value),
                                        )
                                      }
                                      disabled={
                                        !refundedItems.find(
                                          (e: any) =>
                                            e.article._id === item.article._id,
                                        )
                                      }
                                    />
                                  </div>
                                )}
                              <div className="col-2 text-center">
                                {(
                                  item.prix_unitaire *
                                  item.quantity *
                                  ((100 - (item.remise || 0)) / 100)
                                ).toFixed(3)}
                                {parametrage.defaultCurrency}
                              </div>
                              {refundedItems.find(
                                (e: any) => e.article._id === item.article._id,
                              ) &&
                                refundMode &&
                                soldProducts &&
                                soldProducts[item.article._id] > 0 &&
                                item.quantity > 0 &&
                                itemT.type !== "Avance" &&
                                item.type !== "defaut" && (
                                  <div className="row mt-3">
                                    <div className="col-1"></div>
                                    <div className="user-email  text-center col-3">
                                      <label>{t("Note")}</label>
                                      <textarea
                                        className="form-control"
                                        onChange={(e) => {
                                          changeinfodefaut(
                                            index,
                                            "note",
                                            e.target.value,
                                          );
                                        }}
                                        value={
                                          refundedItems.find(
                                            (e: any) =>
                                              e.article._id ===
                                              item.article._id,
                                          )?.note || ""
                                        }
                                      />
                                    </div>
                                    <div className="user-email  text-center mt-4 col-2">
                                      <Form.Check
                                        // prettier-ignore
                                        type="switch"
                                        id="custom-switch"
                                        label="article défectueux"
                                        onChange={(e) => {
                                          // Safely find the item in refundedItems array
                                          const itemToUpdate =
                                            refundedItems.find(
                                              (e: any) =>
                                                e.article._id ===
                                                item.article._id,
                                            );

                                          if (itemToUpdate) {
                                            changeinfodefaut(
                                              index,
                                              "type",
                                              !itemToUpdate.type,
                                            );
                                          }
                                        }}
                                        value={
                                          refundedItems.find(
                                            (e: any) =>
                                              e.article._id ===
                                              item.article._id,
                                          )?.type || false
                                        }
                                      />
                                    </div>

                                    {refundedItems.find(
                                      (e: any) =>
                                        e.article._id === item.article._id,
                                    ).type && (
                                      <>
                                        <div className="user-email  text-center col-2">
                                          <label>{t("Quantite defaut")}</label>
                                          <input
                                            type="number"
                                            className="form-control "
                                            onChange={(e) => {
                                              changeinfodefaut(
                                                index,
                                                "quantite",
                                                e.target.value,
                                              );
                                            }}
                                            value={
                                              refundedItems.find(
                                                (e: any) =>
                                                  e.article._id ===
                                                  item.article._id,
                                              )?.quantite
                                            }
                                          />
                                        </div>
                                        <div className="user-email  text-center col-2">
                                          <label>{t("Image")}</label>
                                          <input
                                            type="file"
                                            className="form-control"
                                            onChange={(e) => {
                                              const file = e.target.files
                                                ? e.target.files[0]
                                                : null;
                                              if (file) {
                                                changeinfodefaut(
                                                  index,
                                                  "image",
                                                  file,
                                                ); // Pass the file object instead of value
                                              }
                                            }}
                                            // Ensure that this value is managed correctly for file inputs (it should be an empty string or null)
                                            accept="image/*" // Optional: restrict to image files only
                                          />
                                        </div>
                                      </>
                                    )}
                                  </div>
                                )}
                              <div className="row mt-5">
                                {item?.note ? (
                                  <div className="col-4 row">
                                    <span>
                                      <strong>{t("Note")}: </strong>
                                      <span>{item?.note}</span>
                                    </span>
                                  </div>
                                ) : null}
                                {itemT?.ticket_order?.defaut !== null &&
                                  itemT?.ticket_order?.defaut?.length !== 0 && (
                                    <>
                                      {}
                                      <div className="col-3">
                                        <span>
                                          {t("Nombre article defectueux : ")}{" "}
                                          {
                                            itemT?.ticket_order?.defaut?.find(
                                              (d: any) =>
                                                d.article === item.article._id,
                                            )?.Quantite
                                          }
                                        </span>
                                      </div>
                                      {itemT?.ticket_order?.defaut?.find(
                                        (d: any) =>
                                          d.article === item.article._id,
                                      )?.image !== null && (
                                        <div className="col-4">
                                          <Zoom>
                                            <img
                                              alt=""
                                              src={
                                                itemT?.ticket_order?.defaut?.find(
                                                  (d: any) =>
                                                    d.article ===
                                                    item.article._id,
                                                )?.image
                                                  ? process.env
                                                      .REACT_APP_API_PUBLIC_URL +
                                                    "articledefectueux/" +
                                                    itemT?.ticket_order?.defaut?.find(
                                                      (d: any) =>
                                                        d.article ===
                                                        item.article._id,
                                                    )?.image
                                                  : "/assets/assets/img/no-image.jpg"
                                              }
                                              width="50"
                                            />
                                          </Zoom>
                                        </div>
                                      )}
                                    </>
                                  )}
                              </div>
                            </div>
                          </>
                        ),
                      )}

                      {/* Ticket button */}
                      <div className="mt-2">
                        <button
                          className="btn btn-secondary"
                          onClick={async () => {
                            console.log("call");
                            if (itemT.type === "Avance") {
                              callImpression(itemT, "Avance");

                              // setticketselected(itemT);
                            } else {
                              console.log("Ticket");

                              // setShowModa
                              // lTicket(true);
                              callImpression(itemT, "Ticket Paid");
                              //  setticketselected(itemT);
                            }
                          }}
                        >
                          {t("Ticket")}
                        </button>
                        <button
                          className="btn btn-secondary ml-2"
                          onClick={() => setShowOrderDetailsModal(true)}
                        >
                          {t("Afficher ticket")}
                        </button>
                      </div>
                    </div>
                  ))}
            </div>
          </div>
        ) : (
          openedOrder?.items.map((item: any, index: number) => (
            <div className={"widget-profile"} key={index}>
              <div className={"w-profile-view" + boxClass}>
                <div className="col-6">
                  <div
                    className="w-profile-content"
                    style={{ display: "flex" }}
                  >
                    <img
                      src={
                        item.image && item.image[0]
                          ? process.env.REACT_APP_API_PUBLIC_URL +
                            "/article/" +
                            item.image[0]
                          : "/assets/assets/img/no-image.jpg"
                      }
                      alt="admin-profile"
                      className="img-fluid"
                    />
                    <div>
                      <h6
                        style={{
                          fontSize:
                            parametrage && parametrage.barcodeOnly
                              ? "30px"
                              : "14px",
                          fontWeight: "lighter",
                        }}
                      >
                        {item.article.titre.fr}
                      </h6>
                      {item.article.caracteristiques.length ? (
                        <p>
                          {item.article.caracteristiques.map(
                            (caracteristique: any) =>
                              caracteristique?.value?.libelle
                                ? caracteristique?.value?.libelle + " "
                                : caracteristique?.value + " ",
                          )}
                        </p>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div
                  className="col-6"
                  style={{
                    alignItems: "center",
                    justifyContent: "right",
                    display: "flex",
                    padding: 0,
                  }}
                >
                  <div
                    className="w-profile-links"
                    style={{
                      padding: "0",
                      alignItems: "center",
                    }}
                  >
                    <span className={"w-p-link" + btnClass}>
                      <p>{item.quantity}</p>
                    </span>

                    <span
                      className={"w-p-link" + btnClass}
                      style={{ width: "auto", justifyContent: "center" }}
                    >
                      <p>{item.prix_total.toFixed(3)}</p>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))
        )
      ) : null}
      {openedOrder?.status !== "Annulée" &&
        openedOrder &&
        openedOrder.status !== "demande accepter" && (
          <div className="action-area">
            {refundMode ? (
              <button
                className="btn btn-danger"
                onClick={() => setRefundMode(!refundMode)}
              >
                {t("Annuler ")}
                {typeAction}
              </button>
            ) : (
              <>
                {openedOrder &&
                openedOrder.status !== "reservation" &&
                openedOrder.status !== "Avoir" ? (
                  <>
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        setRefundMode(!refundMode);
                        setTypeAction("Echange");
                      }}
                      disabled={isExpired(
                        openedOrder?.date,
                        parametrage?.duree_retour,
                      )}
                    >
                      {t("Echange")}
                    </button>
                    {isOnlineSale ? (
                      <button
                        className="btn btn-primary ml-2"
                        onClick={() => {
                          onlineRefund();
                        }}
                        // disabled={isExpired(
                        //   openedOrder?.date,
                        //   parametrage?.duree_retour,
                        // )}
                      >
                        {t("Retour")}
                      </button>
                    ) : null}
                    {!isOnlineSale ? (
                      <button
                        disabled={
                          isExpired(
                            openedOrder?.date,
                            parametrage?.duree_retour,
                          ) ||
                          (etatRetour && etatRetour.confirmed === false)
                        }
                        className="btn btn-danger ml-2"
                        onClick={() => {
                          setTypeAction("Retour");
                          if (etatRetour) {
                            headToRetour(0, etatRetour.itemsToReturn);
                          } else {
                            setRefundMode(!refundMode);
                          }
                        }}
                      >
                        {t("Retour")}{" "}
                        {etatRetour &&
                        etatRetour.confirmed === false &&
                        !etatRetour.cloture ? (
                          <>
                            {t(" : Demande de retour en cours ")}
                            <i className="fas fa-spinner"></i>
                          </>
                        ) : etatRetour &&
                          etatRetour.confirmed === true &&
                          !etatRetour.cloture ? (
                          <>
                            {t(" : confirmé ")}
                            <i
                              className="fas fa-check"
                              style={{ color: "#78d9bc" }}
                            ></i>
                          </>
                        ) : null}
                      </button>
                    ) : null}
                  </>
                ) : (
                  openedOrder.status !== "Avoir" && (
                    <span className="btn btn-danger" onClick={AjoutAvance}>
                      {t("Payer /Ajout avance")}
                    </span>
                  )
                )}
                {openedOrder &&
                  (openedOrder.status === "Payée" ||
                    openedOrder.status === "reservation") &&
                  openedOrder?.createdAt?.split("T")[0] === today &&
                  (user?.role_id?.libelle !== "admin" ? (
                    <button
                      className="btn btn-danger ml-2"
                      onClick={sendSmsDemandeAnnulation}
                    >
                      {t("Annuler Vente")}
                    </button>
                  ) : (
                    <button
                      className="btn btn-danger ml-2"
                      onClick={() => annulerOrder(false, true, false)}
                    >
                      {t("Annuler Vente")}
                    </button>
                  ))}
              </>
            )}

            {refundMode && refundedItems.length > 0 && (
              <button
                className="btn btn-warning "
                onClick={() => headToRetour(0, refundedItems)}
              >
                {typeAction} les articles sélectionnés
              </button>
            )}
          </div>
        )}
      {user?.role_id?.libelle !== "admin" &&
        openedOrder?.status === "demande accepter" &&
        openedOrder && (
          <>
            <span
              className="btn btn-danger mt-2"
              onClick={() => annulerOrder(true, true, false)}
            >
              {t("continuer  l'annulation")}
            </span>

            <span
              className="btn btn-success mt-2"
              onClick={() => annulerOrder(false, false, false)}
            >
              {t("Annuler  l'annulation")}
            </span>
          </>
        )}
      {openedOrder &&
        openedOrder.status === "demande annulation" &&
        (user?.role_id?.libelle !== "admin" ? (
          <span className="btn btn-danger">
            {t("Demande d'annulation en cours de traitement")}
          </span>
        ) : (
          <>
            <span
              className="btn btn-danger mt-2"
              onClick={() => annulerOrder(false, false, false)}
            >
              {t("Refuser l'annulation")}
            </span>
            <span
              className="btn btn-success mt-2"
              onClick={() => annulerOrder(false, true, true)}
            >
              {t("Confirmer  l'annulation")}
            </span>
          </>
        ))}

      <TicketCommande
        ShowModal={showModalTicket}
        setShowModal={setShowModalTicket}
        order_id={openedOrder?._id}
        ticket={ticketselected}
      />
      <OrderDetailsModal
        show={showOrderDetailsModal}
        setShow={setShowOrderDetailsModal}
        order_id={openedOrder?._id}
      />
      <TicketArticle
        t={t}
        ShowModal={showModelTicketArticle}
        setShowModal={setshowModelTicketArticle}
        tickets={listTicket}
        stateQte={false}
         impression={true}
      />
      {showModelAvanceTicketArticle && (
        <TicketAvance
          ShowModal={showModelAvanceTicketArticle}
          setShowModal={setshowModelAvanceTicketArticle}
          ticket={ticketselected}
          reservation={Reservation}
        />
      )}
    </div>
  );
};

export default PaidOrder;
